import { Navigate } from 'react-router-dom';
import { WORKSPACE_CANVAS_MODES } from '@/components/workspace/workspaceMode';

const IntegrationsPage = () => <Navigate to={`/studio?canvas=${WORKSPACE_CANVAS_MODES.etsySetup}`} replace />;

export default IntegrationsPage;
